import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { format } from 'date-fns';
import { Calendar } from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { useUser } from '../context/UserContext';

const SupplierMenu = () => {
  const { authFetch } = useUser();
  const [dishes, setDishes] = useState([]);
  const [calendarOpenIndex, setCalendarOpenIndex] = useState(null);
  const [tempSelectedDates, setTempSelectedDates] = useState([]);
  const [message, setMessage] = useState(null);

  //useEffect(() => {
   // const fetchDishes = async () => {
      //try {
      //  const data = await authFetch('/supplier/dishes');
       // setDishes(data.filter(d => !d.submitted));

    //  } catch (err) {
       // console.error('Ошибка загрузки блюд:', err);
    //  }
//};
//
  //  fetchDishes();
//  }, [authFetch]);

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000);
  };

  const saveDishesToDB = async (updated) => {
    if (!updated || !Array.isArray(updated) || updated.length === 0) return;
  
    try {
      const successfullySaved = [];
      // const dishesForMainPublishing = []; // Этот массив не используется, можно удалить или переосмыслить
  
      for (const dish of updated) {
        if (!dish.name || !dish.price || !dish.image || dish.days.length === 0) {
          console.warn('Пропущено блюдо без необходимых данных (основные поля):', dish);
          continue;
        }
  
        // Данные для публикации в основное меню (/dishes)
        const formData = new FormData();
        formData.append('name', dish.name);
        formData.append('price', dish.price);
        formData.append('ingredients', dish.description || '');
        formData.append('image', dish.image); // это File объект
        formData.append('days', JSON.stringify(dish.days));
        formData.append('dishClass', dish.dishClass || ''); // ✅ Добавляем dishClass для /api/dishes
        formData.append('hasGarnir', dish.hasGarnir);
        
        await authFetch('/dishes', {
          method: 'POST',
          body: formData,
        });
        
        successfullySaved.push({
          name: dish.name,
          price: dish.price,
          description: dish.description || '',
          imageUrl: dish.imageUrl,
          days: dish.days,
          dishClass: dish.dishClass || '',
          hasGarnir: dish.hasGarnir

        });
      }
  
      if (successfullySaved.length > 0) {
        await authFetch('/supplier/dishes', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(successfullySaved)
        });
      }
  
      showMessage('Блюда успешно опубликованы и сохранены в историю');
      setDishes([]);
      setTempSelectedDates([]);
      setCalendarOpenIndex(null);
    } catch (err) {
      console.error('Ошибка сохранения блюд:', err);
      showMessage(err.message || 'Ошибка при сохранении', 'error');
    }
  };
  
  

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      const formatted = parsedData.map((item, index) => ({
        id: index + 1,
        name: item['Название блюда'] || '',
        price: item['Цена'] || '',
        description: item['Грамовка/описание'] || '',
        days: [],
        image: null,
        imagePreview: null,
        dishClass: item['Класс блюда'] || '',
        hasGarnir: false


      }));
      setDishes(formatted);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleImageChange = async (index, file) => {
    const previewUrl = URL.createObjectURL(file);
    const formData = new FormData();
    formData.append('image', file);
  
    try {
      const response = await authFetch('/upload/image', {
        method: 'POST',
        body: formData
      });
  
      if (response?.url) {
        setDishes(prev => {
          const updated = [...prev];
          updated[index].image = file;
          updated[index].imagePreview = previewUrl;
          updated[index].imageUrl = response.url;
          return updated;
        });
      } else {
        throw new Error('Некорректный ответ от сервера');
      }
  
    } catch (err) {
      console.error('Ошибка загрузки изображения:', err);
      showMessage('Ошибка при загрузке изображения', 'error');
    }
  };
  

  const handleDateApply = (index) => {
    setDishes(prev => {
      const updated = [...prev];
      updated[index].days = tempSelectedDates.map(date => format(new Date(date), 'dd.MM.yyyy'));
      return updated;
    });
    setCalendarOpenIndex(null);
    setTempSelectedDates([]);
  };

  const handleAddDish = () => {
    setDishes(prev => ([
      ...prev,
      {
        id: prev.length + 1,
        name: '',
        price: '',
        description: '',
        days: [],
        image: null,
        imagePreview: null,
        dishClass: '',
  hasGarnir: false
      }
    ]));
  };

  const handleChangeField = (index, field, value) => {
    setDishes(prev => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  return (
    <div className="p-6 text-white max-w-6xl mx-auto space-y-6">
      <h1 className="text-3xl font-bold text-center text-teal-400">Меню поставщика 🍱</h1>

      {message && (
        <div className={`text-center text-sm py-2 px-4 rounded shadow ${message.type === 'error' ? 'bg-red-600' : 'bg-green-600'} text-white`}>
          {message.text}
        </div>
      )}

      <div className="text-center space-x-4">
        <button
          onClick={handleAddDish}
          className="bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded shadow"
        >
          ➕ Добавить блюдо вручную
        </button>

        <label className="cursor-pointer inline-block">
          <span className="bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded shadow">
            📂 Загрузить Excel
          </span>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            className="hidden"
          />
        </label>

        <button
          onClick={() => saveDishesToDB(dishes)}
          className="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded shadow"
        >
          💾 Сохранить
        </button>
      </div>

      {dishes.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-800 border border-gray-600 rounded-md shadow-md">
            <thead>
              <tr className="bg-gray-700 text-left text-sm uppercase text-gray-300">
                <th className="px-4 py-2">Название блюда</th>
                <th className="px-4 py-2">Цена</th>
                <th className="px-4 py-2">Грамовка / описание</th>
                <th className="px-4 py-2">Класс блюда</th>
                <th className="px-4 py-2">Даты</th>
                <th className="px-4 py-2">Гарнир к блюду</th>
<th className="px-4 py-2">Фото</th>


              </tr>
            </thead>
            <tbody>
              {dishes.map((dish, index) => (
                <React.Fragment key={dish.id}>
                  <tr className="border-t border-gray-700">
                    <td className="px-4 py-2">
                      <input
                        type="text"
                        value={dish.name}
                        onChange={e => handleChangeField(index, 'name', e.target.value)}
                        className="w-full bg-gray-700 text-white p-1 rounded"
                      />
                    </td>
                    <td className="px-4 py-2">
                      <input
                        type="text"
                        value={dish.price}
                        onChange={e => handleChangeField(index, 'price', e.target.value)}
                        className="w-full bg-gray-700 text-white p-1 rounded"
                      />
                    </td>
                    <td className="px-4 py-2">
                      <input
                        type="text"
                        value={dish.description}
                        onChange={e => handleChangeField(index, 'description', e.target.value)}
                        className="w-full bg-gray-700 text-white p-1 rounded"
                      />
                    </td>
                    <td className="px-4 py-2">
                      <select
                        value={dish.dishClass}
                        onChange={e => handleChangeField(index, 'dishClass', e.target.value)}
                        className="w-full bg-gray-700 text-white p-1 rounded"
                      >
                        <option value="">Не выбрано</option>
                        <option value="первое">Первое</option>
                        <option value="второе">Второе</option>
                        <option value="салат">Салат</option>
                        <option value="гарнир">Гарнир</option>
                        <option value="напиток">Напиток</option>
                      </select>
                    </td>
                    <td className="px-4 py-2 relative">
                      <button
                        onClick={() => {
                          setCalendarOpenIndex(index);
                          setTempSelectedDates(dish.days.map(date => new Date(date)));
                        }}
                        className="bg-gray-700 hover:bg-gray-600 text-white text-sm px-2 py-1 rounded flex items-center gap-1"
                      >
                        <CalendarDaysIcon className="h-4 w-4" />
                        Выбрать
                      </button>
                      <div className="text-xs text-gray-400 mt-1">
                        {dish.days.length > 0 ? dish.days.join(', ') : 'Не выбрано'}
                      </div>
                    </td>
                    {dish.dishClass === 'второе' && (
  <td className="px-4 py-2">
    <select
      value={dish.hasGarnir ? 'yes' : 'no'}
      onChange={(e) => handleChangeField(index, 'hasGarnir', e.target.value === 'yes')}
      className="w-full bg-gray-700 text-white p-1 rounded"
    >
      <option value="no">Нет</option>
      <option value="yes">Да</option>
    </select>
  </td>
)}


                    <td className="px-4 py-2">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageChange(index, e.target.files[0])}
                        className="text-xs text-gray-300"
                      />
                      {dish.imagePreview && (
                        <img
                          src={dish.imagePreview}
                          alt="preview"
                          className="mt-2 w-20 h-20 object-cover rounded border border-gray-600"
                        />
                      )}
                    </td>
                  </tr>
                  {calendarOpenIndex === index && (
                    <tr>
                      <td colSpan="5" className="px-4 pt-2 pb-4">
                        <div className="bg-white rounded-md shadow-lg p-4 max-w-md mx-auto">
                          <Calendar
                            multiple
                            format="DD.MM.YYYY"
                            value={tempSelectedDates}
                            onChange={setTempSelectedDates}
                            className="text-black"
                          />
                          <div className="mt-4 text-center">
                            <button
                              onClick={() => handleDateApply(index)}
                              className="bg-teal-600 hover:bg-teal-700 text-white py-1 px-4 rounded"
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SupplierMenu;
